import GameManager from "@/assets/js/GameManager";

export class Action {
    elapsed_time = 0;
    displayTime = 0;
    complete = false;
    constructor(_name, _id, _duration, _health, _callback, _elapsed, _timestamp) {
        this.name = _name;
        this.id = _id;
        this.duration = _duration ? _duration * 1000 : 0; // Duration is given in seconds, but we track in milliseconds
        this.health = _health;
        this.callback = _callback;
        this.displayTime = _duration;
        this.timestamp = _timestamp || Date.now();
        this.that = this;
        if(_elapsed){
            this.elapsed_time = _elapsed;
            if(this.elapsed_time >= this.duration) this.complete = true;
        }
    }
    createSaveData(){
        let action = {
            name: this.name,
            id: this.id,
            duration: this.duration/1000, // (gotta convert back to seconds)
            health: this.health,
            timestamp: this.timestamp,
            tip: this.tip
        }
        return {
            action: action,
            elapsed: this.elapsed_time
        }
    }
    tick(){
        if(this.complete) return;
        if(!GameManager.paused){
            this.elapsed_time += GameManager.timeDelta;
        }
        if(this.elapsed_time > this.duration){
            this.complete = true;
            if(typeof this.callback === 'function' ) this.callback.call();
        } else {
            this.displayTime = Math.ceil((this.duration - this.elapsed_time)/1000);
            window.requestAnimationFrame(this.tick.bind(this));
        }
    }
}
